<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <date-picker
      :name="fieldName"
      class="twenty-five-percent"
      :data-vv-as="field.label"
      v-model="proxyValue"
      v-validate="fieldValidationRules"
      type="date"
      :format="constants.DATE.FORMAT.DISPLAY"
      :value-format="constants.DATE.FORMAT.VALUE"
      :placeholder="field.placeholder"
      :editable=false
      :disabled="isTaskFieldDisabled"
      :picker-options="datePickerConfig">
    </date-picker>
    <small class="text-danger" v-show="errors.has(fieldName)" style="display:block; margin-top: 7px;">
      {{ getError(fieldName) }}
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'
  import {DatePicker} from 'element-ui'
  import datePickerConfig from 'src/components/UIComponents/DatePicker/datePickerConfig'
  import Constants from 'src/utilities/constants'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    components: {
      DatePicker
    },
    computed: {
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        constants: Constants,
        datePickerConfig,
        fieldValidation: {},
        statusOnLoad: null
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
  .twenty-five-percent {
    width: 25%
  }
</style>
